export default __webpack_public_path__ + "static/media/whatsapp-footer.8cea61f6.svg";